export const transformFilters = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.selectedData && filter.selectedData.length > 0) {
        acc[filter.label] = filter.selectedData;
      }
      return acc;
    }, {});
  };